import { StyleSheet } from "react-native";
import { webFont } from "../../../Universal/API/API";

export const createListOfUnitsV3Styles = (scaleAll: number) =>
  StyleSheet.create({
    listContainer: {
      flex: 1,
    },
    listContent: {},
    cardOuter: {
      width: "100%",
      paddingHorizontal: 8 * scaleAll,
      paddingVertical: 10 * scaleAll,
    },
    cardPressable: {
      width: "100%",
      cursor: "pointer",
    },
    card: {
      width: "100%",
      backgroundColor: "#FFFFFF",
      borderRadius: 28 * scaleAll,
      borderWidth: 1,
      borderColor: "#ECECEC",
      overflow: "hidden",
      shadowColor: "#000",
      shadowOpacity: 0.05,
      shadowRadius: 20,
      shadowOffset: { width: 0, height: 14 },
      elevation: 3,
    },
    cardHovered: {
      shadowOpacity: 0.14,
      shadowRadius: 34,
      shadowOffset: { width: 0, height: 22 },
      elevation: 6,
      borderColor: "#E4E4E4",
    },
    mediaShell: {
      width: "100%",
      backgroundColor: "#FBFBFB",
      borderBottomWidth: 1,
      borderBottomColor: "#F1F1F1",
      paddingHorizontal: 14 * scaleAll,
      paddingTop: 12 * scaleAll,
      paddingBottom: 10 * scaleAll,
      height: 268 * scaleAll,
      justifyContent: "space-between",
    },
    mediaShellSmall: {
      height: 212 * scaleAll,
      paddingHorizontal: 10 * scaleAll,
      paddingTop: 8 * scaleAll,
      paddingBottom: 8 * scaleAll,
    },
    mediaTopRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 8 * scaleAll,
      minHeight: 38 * scaleAll,
    },
    collectionChip: {
      alignSelf: "flex-start",
      borderRadius: 999,
      backgroundColor: "#111111",
      paddingHorizontal: 11 * scaleAll,
      paddingVertical: 7 * scaleAll,
      maxWidth: "70%",
    },
    collectionChipSmall: {
      paddingHorizontal: 8 * scaleAll,
      paddingVertical: 5 * scaleAll,
    },
    collectionChipText: {
      fontFamily: webFont("Inter"),
      fontSize: 11 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
    collectionChipTextSmall: {
      fontSize: 9 * scaleAll,
    },
    galleryCountPill: {
      borderRadius: 999,
      backgroundColor: "rgba(255,255,255,0.96)",
      borderWidth: 1,
      borderColor: "#ECECEC",
      paddingHorizontal: 10 * scaleAll,
      paddingVertical: 7 * scaleAll,
    },
    galleryCountPillSmall: {
      paddingHorizontal: 8 * scaleAll,
      paddingVertical: 5 * scaleAll,
    },
    galleryCountText: {
      fontFamily: webFont("Inter"),
      fontSize: 11 * scaleAll,
      color: "#4A4A4A",
      fontWeight: "600",
    },
    galleryCountTextSmall: {
      fontSize: 9.5 * scaleAll,
    },
    mediaCenter: {
      width: "100%",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      paddingVertical: 2 * scaleAll,
    },
    mediaViewport: {
      width: "100%",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    mediaImageFrame: {
      width: "80%",
      height: "80%",
      alignItems: "center",
      justifyContent: "center",
    },
    mediaImageFrameSmall: {
      width: "84%",
      height: "84%",
    },
    mediaImage: {
      width: "100%",
      height: "100%",
    },
    mediaPlaceholder: {
      width: "100%",
      height: 150 * scaleAll,
      borderRadius: 20 * scaleAll,
      backgroundColor: "#F1F1F1",
    },
    mediaHintRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 10 * scaleAll,
      marginTop: 8 * scaleAll,
    },
    artPill: {
      alignSelf: "flex-start",
      borderRadius: 999,
      backgroundColor: "#F4F4F4",
      borderWidth: 1,
      borderColor: "#E7E7E7",
      paddingHorizontal: 10 * scaleAll,
      paddingVertical: 7 * scaleAll,
      cursor: "pointer",
    },
    artPillSmall: {
      paddingHorizontal: 8 * scaleAll,
      paddingVertical: 5 * scaleAll,
    },
    artPillText: {
      fontFamily: webFont("Inter"),
      fontSize: 11 * scaleAll,
      color: "#202020",
      fontWeight: "600",
    },
    artPillTextSmall: {
      fontSize: 9.5 * scaleAll,
    },
    body: {
      paddingHorizontal: 16 * scaleAll,
      paddingTop: 14 * scaleAll,
      paddingBottom: 16 * scaleAll,
    },
    bodySmall: {
      paddingHorizontal: 12 * scaleAll,
      paddingTop: 12 * scaleAll,
      paddingBottom: 12 * scaleAll,
    },
    title: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      lineHeight: 22 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      minHeight: 66 * scaleAll,
    },
    titleSmall: {
      fontSize: 13 * scaleAll,
      lineHeight: 18 * scaleAll,
      minHeight: 54 * scaleAll,
    },
    factsRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 4 * scaleAll,
      marginTop: 10 * scaleAll,
      marginBottom: 14 * scaleAll,
      minHeight: 34 * scaleAll,
    },
    factsRowSmall: {
      gap: 3 * scaleAll,
      marginTop: 8 * scaleAll,
      marginBottom: 12 * scaleAll,
      minHeight: 0,
    },
    factChip: {
      borderRadius: 999,
      borderWidth: 1,
      borderColor: "#ECECEC",
      backgroundColor: "#FFFFFF",
      paddingHorizontal: 8 * scaleAll,
      paddingVertical: 7 * scaleAll,
    },
    factChipSmall: {
      paddingHorizontal: 6 * scaleAll,
      paddingVertical: 4 * scaleAll,
    },
    factChipText: {
      fontFamily: webFont("Inter"),
      fontSize: 11 * scaleAll,
      color: "#575757",
      fontWeight: "500",
    },
    factChipTextSmall: {
      fontSize: 8.5 * scaleAll,
    },
    footerRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-end",
      gap: 12 * scaleAll,
      minHeight: 42 * scaleAll,
    },
    footerRowSmall: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: 8 * scaleAll,
      minHeight: 0,
    },
    actionHintsRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: 8 * scaleAll,
      maxWidth: "62%",
    },
    actionHintsRowSmall: {
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
    },
    actionHintsRowCounterSmall: {
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
    },
    cartSlot: {
      position: "relative",
      width: 172 * scaleAll,
      minHeight: 56 * scaleAll,
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
    cartSlotSmall: {
      width: "100%",
      minHeight: 44 * scaleAll,
      alignItems: "stretch",
    },
    cartSlotCounterSmall: {
      width: "100%",
      minHeight: 44 * scaleAll,
      alignItems: "stretch",
    },
    priceWrap: {
      flex: 1,
      minWidth: 0,
    },
    priceLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 11 * scaleAll,
      color: "#7A7A7A",
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
      marginBottom: 4 * scaleAll,
    },
    priceLabelSmall: {
      display: "none",
      marginBottom: 0,
    },
    priceText: {
      fontFamily: webFont("Inter"),
      fontSize: 18 * scaleAll,
      lineHeight: 22 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    priceTextSmall: {
      fontSize: 14 * scaleAll,
      lineHeight: 17 * scaleAll,
    },
    priceTextCompactDesktop: {
      fontSize: 16 * scaleAll,
      lineHeight: 20 * scaleAll,
    },
    cartActionButton: {
      position: "absolute",
      right: 0,
      bottom: 0,
      borderRadius: 999,
      backgroundColor: "#111111",
      minHeight: 40 * scaleAll,
      paddingHorizontal: 16 * scaleAll,
      paddingVertical: 9 * scaleAll,
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
    },
    cartActionButtonSmall: {
      left: 0,
      width: "100%",
      minWidth: 0,
      height: 42 * scaleAll,
      minHeight: 42 * scaleAll,
      paddingHorizontal: 12 * scaleAll,
      paddingVertical: 0,
    },
    cartActionButtonInner: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8 * scaleAll,
    },
    cartActionButtonInnerSmall: {
      gap: 6 * scaleAll,
      justifyContent: "center",
    },
    cartActionButtonIcon: {
      marginTop: 0,
    },
    cartActionButtonText: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "700",
      letterSpacing: 0.5,
      textTransform: "uppercase",
    },
    cartActionButtonTextSmall: {
      fontSize: 9.5 * scaleAll,
      letterSpacing: 0.2,
    },
    cartCounterCard: {
      position: "absolute",
      right: 0,
      bottom: 0,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: 172 * scaleAll,
      minHeight: 56 * scaleAll,
      borderRadius: 20 * scaleAll,
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#EAEAEA",
      paddingLeft: 14 * scaleAll,
      paddingRight: 8 * scaleAll,
      paddingVertical: 8 * scaleAll,
    },
    cartCounterCardSmall: {
      width: 108 * scaleAll,
      minHeight: 44 * scaleAll,
      borderRadius: 16 * scaleAll,
      paddingLeft: 8 * scaleAll,
      paddingRight: 6 * scaleAll,
      paddingVertical: 6 * scaleAll,
    },
    cartCounterCompactSmall: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      minHeight: 42 * scaleAll,
      borderRadius: 16 * scaleAll,
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#EAEAEA",
      paddingLeft: 6 * scaleAll,
      paddingRight: 6 * scaleAll,
      paddingVertical: 6 * scaleAll,
    },
    cartCounterMeta: {
      flex: 1,
      paddingRight: 8 * scaleAll,
    },
    cartCounterTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 9.5 * scaleAll,
      color: "#7A746C",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: 0.55,
      marginBottom: 3 * scaleAll,
    },
    cartCounterTitleSmall: {
      fontSize: 7.5 * scaleAll,
      marginBottom: 2 * scaleAll,
    },
    cartCounterValue: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      letterSpacing: 0.2,
    },
    cartCounterValueSmall: {
      fontSize: 11.5 * scaleAll,
    },
    cartCounterValueCompactSmall: {
      flex: 1,
      textAlign: "center",
      fontSize: 14 * scaleAll,
      letterSpacing: 0,
    },
    cartCounterValueCompactDesktop: {
      flex: 1,
      textAlign: "center",
      fontSize: 16 * scaleAll,
      letterSpacing: 0,
    },
    cartCounterActions: {
      flexDirection: "row",
      alignItems: "center",
      gap: 6 * scaleAll,
    },
    cartCounterGhostButton: {
      width: 36 * scaleAll,
      height: 36 * scaleAll,
      borderRadius: 12 * scaleAll,
      borderWidth: 1,
      borderColor: "#E2E2E2",
      backgroundColor: "#FFFFFF",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    cartCounterGhostButtonSmall: {
      width: 30 * scaleAll,
      height: 30 * scaleAll,
      borderRadius: 10 * scaleAll,
    },
    cartCounterPrimaryButton: {
      width: 36 * scaleAll,
      height: 36 * scaleAll,
      borderRadius: 12 * scaleAll,
      backgroundColor: "#111111",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    cartCounterPrimaryButtonSmall: {
      width: 30 * scaleAll,
      height: 30 * scaleAll,
      borderRadius: 10 * scaleAll,
    },
  });

export type ListOfUnitsV3Styles = ReturnType<typeof createListOfUnitsV3Styles>;
